import { Link } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';

// Logo URLs
const LOGO_ICON = "/images/logos/logo-color.png";
const LOGO_DARK_FULL = "/images/logos/logo-white.png";

// Zones d'intervention pour le SEO
const ZONES_VILLES = [
  { name: 'Bourg-en-Bresse', slug: 'bourg-en-bresse' },
  { name: 'Lyon', slug: 'lyon' },
  { name: 'Suisse', slug: 'suisse' },
];

const ZONES_DEPARTEMENTS = [
  { name: 'Ain (01)', slug: 'ain' },
  { name: 'Savoie (73)', slug: 'savoie' },
  { name: 'Haute-Savoie (74)', slug: 'haute-savoie' },
];

export function Footer() {
  const currentYear = new Date().getFullYear();
  const { theme } = useTheme();

  return (
    <footer data-testid="footer" className="bg-muted/50 border-t border-border">
      <div className="container-main py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link to="/" className="inline-block mb-4">
              <img 
                src={theme === 'dark' ? LOGO_DARK_FULL : LOGO_ICON} 
                alt="Axeris Labs" 
                className="h-12 w-auto object-contain"
              />
            </Link>
            <p className="text-muted-foreground max-w-md">
              Création de sites web sur-mesure, modernes et performants. 
              Des solutions abordables pour les entrepreneurs et PME.
            </p>
          </div>

          {/* Zones d'intervention - Column 1 */}
          <div>
            <h4 className="font-bold text-lg mb-4">Zones d'intervention</h4>
            <nav className="flex flex-col gap-3">
              {ZONES_VILLES.map((zone) => (
                <Link
                  key={zone.slug}
                  to={`/creation-site-web-${zone.slug}`}
                  className="text-muted-foreground hover:text-primary transition-colors"
                >
                  {zone.name}
                </Link>
              ))}
            </nav>
          </div>

          {/* Zones d'intervention - Column 2 */}
          <div>
            <h4 className="font-bold text-lg mb-4">Départements</h4>
            <nav className="flex flex-col gap-3">
              {ZONES_DEPARTEMENTS.map((zone) => (
                <Link
                  key={zone.slug}
                  to={`/creation-site-web-${zone.slug}`}
                  className="text-muted-foreground hover:text-primary transition-colors"
                >
                  {zone.name}
                </Link>
              ))}
            </nav>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-bold text-lg mb-4">Informations</h4>
            <nav className="flex flex-col gap-3">
              <Link
                to="/mentions-legales"
                data-testid="footer-link-mentions"
                className="text-muted-foreground hover:text-primary transition-colors"
              >
                Mentions légales
              </Link>
              <Link
                to="/politique-confidentialite"
                data-testid="footer-link-privacy"
                className="text-muted-foreground hover:text-primary transition-colors"
              >
                Politique de confidentialité
              </Link>
              <Link
                to="/cgv"
                data-testid="footer-link-cgv"
                className="text-muted-foreground hover:text-primary transition-colors"
              >
                CGV
              </Link>
            </nav>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-border mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-muted-foreground">
            {currentYear} Axeris Labs. Tous droits réservés.
          </p>
          <p className="text-sm text-muted-foreground">
            Conçu pour ceux qui osent se lancer.
          </p>
        </div>
      </div>
    </footer>
  );
}
